'use es6';

import { FEEDBACK_SUBMISSION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const FeedbackSubmission = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (_, hasScope) => hasScope('service-feedback-access'),
  objectTypeId: FEEDBACK_SUBMISSION_TYPE_ID,
  referenceObjectType: 'FEEDBACK_SUBMISSION_PROPERTIES'
});
export default FeedbackSubmission;